<div class="row user-col2">
    <div *ngIf="!isSinglePost && !showCommentsOnly" class="col-sm-12">
        <div class="card">
            <div class="card-body" style="padding:20px; cursor:pointer" (click)="openCustomModal(content)">
                <div style="display: flex;cursor:pointer">
                    <img class="rounded-circle image-radius m-r-15"
                         [src]="authentication.userData.contactLogo" alt="" style="cursor:pointer;border-radius: 50% !important; height: 50px; width: 50px;">

                    <input class="form-control" placeholder="Start a post" type="text" style="background-color:white; border-radius: 30px;cursor:pointer" disabled>
                </div>
                <ng-template #content let-c="close" let-d="dismiss">
                    <div class="modal-header" style="border:0px">
                        <h4 style=" font-size: 25px; margin: 0px;" class="modal-title" id="modal-basic-title">Create a post</h4>
                        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
                    </div>
                    <div class="modal-body" style="padding: 0px;">
                        <quill-editor [styles]="{height: '200px'}" [(ngModel)]="postBody" placeholder="Share your thoughts..."></quill-editor>
                    </div>
                    <div class="modal-footer" style="border:0px">

                        <!--<div class="col-xl-6 no-padding" style="text-align:left" *ngIf="relatedTo == 'profile'">
                            <div style="width:100%" ngbDropdown class="d-inline-block">
                                <button style="text-align:left;height: 40px; font-size: 14px; width: 100%" class="btn btn-default" id="dropdownBasic1" ngbDropdownToggle>Share With: <b>{{SelectedShareMenuItem.title}}</b></button>
                                <div style="width:100%" ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                    <div *ngFor="let item of ShareMenuItems" style="cursor:pointer;padding-left:15px !important;padding-right: 0px;" class="dropdown-item">
                                        <div (click)="SubmitShareMenuItem(item)" class="row">
                                            <div class="col-xl-2" style="padding:0px; font-size:20px">
                                                <span style="color:#00A6B6" [ngClass]="item.iconCSS"></span>
                                            </div>
                                            <div class="col-xl-10" style="font-size: 14px;padding:0px">
                                                {{item.title}}
                                                <p style="font-size: 14px;color:#989898;margin:0px;margin-bottom:10px">{{item.description}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>-->

                        <button (click)="sendPost()" [disabled]="DisabledShareBtn" type="submit" class="btn mygistec-main-btn ">{{shareBtn}}</button>
                    </div>
                </ng-template>


            </div>
        </div>

    </div>
    <div class="col-sm-12" *ngFor="let postItem of posts; let i = index">
        <div class="card" style="border-radius:10px">
            <div class="card-body" style="padding:20px; border-radius:5px">
                <div *ngIf="!showCommentsOnly" class="new-users-social" style="margin-bottom: 15px;">
                    <div class="media">
                        <img class="rounded-circle image-radius m-r-15"
                             [src]="postItem.postContactLogo" alt="" style="border-radius: 50% !important; height: 50px; width:
    50px;">
                        <div class="media-body">
                            <div class="col-xl-12 no-padding">
                                <a style="cursor:pointer" *ngIf="postItem.fromPortalUser.isActive" class="m-0 avenir-medium blue-green" (click)="openUserProfile(postItem.fromPortalUser.id)">{{postItem.fromPortalUser.firstName }} {{postItem.fromPortalUser.lastName}}</a>
                                <span *ngIf="!postItem.fromPortalUser.isActive" class="m-0 avenir-medium">{{postItem.fromPortalUser.firstName }} {{postItem.fromPortalUser.lastName}}</span>
                                <span style="margin-right: 5px; margin-left: 5px" *ngIf="postItem.toPortalUser" class="feed-time-date"> wrote on </span>
                                <a style="cursor:pointer" *ngIf="postItem.toPortalUser && postItem.toPortalUser.isActive" class="m-0 avenir-medium blue-green" (click)="openUserProfile(postItem.toPortalUser.id)">{{postItem.toPortalUser.firstName }} {{postItem.toPortalUser.lastName}}</a>
                                <span *ngIf="postItem.toPortalUser && !postItem.toPortalUser.isActive" class="m-0 avenir-medium">{{postItem.toPortalUser.firstName }} {{postItem.toPortalUser.lastName}}</span>
                                <span style="margin-right:5px; margin-left:5px" *ngIf="postItem.to_title != null" class="feed-time-date"> wrote on </span>
                                <a style="cursor:pointer" (click)="openModule(postItem.relatedTo, postItem.relatedId)" *ngIf="postItem.to_title != null" class="m-0 avenir-medium blue-green">{{postItem.to_title}}</a>
                                <a *ngIf="!isSinglePost" (click)="openPost(postItem)" style="float: right;cursor:pointer" class="m-0 avenir-medium blue-green"><i class="fa fa-dot-circle-o"></i></a>
                            </div>
                            <p class="m-0" style="padding:0px;font-size: 13px; line-height: initial; opacity:.5">
                                <span matTooltip="Public" style="margin: 0px;margin-right: 4px;font-size: 14px;" *ngIf="postItem.privacy == 'public'" class="fa fa-globe"></span>
                                <span matTooltip="Connections" style="margin: 0px;margin-right: 4px;font-size: 14px;" *ngIf="postItem.privacy == 'connections'" class="fa fa-users"></span>
                                <span matTooltip="Specific Connection" style="margin: 0px;margin-right: 4px;font-size: 14px;" *ngIf="postItem.privacy == 'specific'" class="fa fa-users"></span>
                                {{postItem.createdDate | timeAgo}}
                            </p>
                        </div><span class="pull-right mt-0"><i data-feather="more-vertical"></i></span>
                    </div>
                </div>
                <div class="timeline-content">
                    <div *ngIf="!showCommentsOnly" style="background-color: transparent; font-size: 20px !important; color: #252525;margin-top: 15px;padding:10px"
                         class="feed-post-text" [innerHTML]="postItem.body">
                    </div>
                    <div *ngIf="!showCommentsOnly && (isNewsFeed == 'true' || relatedTo == 'profile' || isSinglePost) && postItem.to_title != null && postItem.to_title != 'profile'" style="text-align: center; background-color: #effeff; font-size: 20px !important; color: #252525; margin-top: 15px; padding: 10px; border-radius: 10px;"
                         class="feed-post-text">
                        <a (click)="openModule(postItem.relatedTo, postItem.relatedId)" style="font-size: 17px; cursor: pointer; color: #06acb7; " class="m-0 avenir-medium blue-green">
                            Open 
                            <span *ngIf="postItem.relatedTo == 'articles'"> article</span>
                            <span *ngIf="postItem.relatedTo == 'groups'"> group</span>
                            <span *ngIf="postItem.relatedTo == 'discussion'"> discussion</span>
                        </a>
                    </div>
                    <div *ngFor="let media of postItem.postMedia" style="color: #00d6aa">
                        <div *ngIf="!showCommentsOnly && media.contentType.indexOf('image') != -1" class="col no-padding">
                            <a style="cursor: pointer;" (click)="openImagePreview(media.content)"><img class="img-thumbnail" style="border: 1px solid lightgrey;width:100%" [src]="media.content" /></a>


                        </div>
                        <div *ngIf="!showCommentsOnly && media.contentType.indexOf('video') != -1" class="col no-padding">
                            <video style="width:100%" controls [src]="media.content">
                                The �video� tag is not supported by your browser.
                            </video>
                        </div>
                        <div *ngIf="!showCommentsOnly && media.contentType.indexOf('video') == -1 && media.contentType.indexOf('image') == -1" class="=col no-padding">
                            <span class="fa fa-file" style="margin-right:15px"></span>
                            <a style="cursor: pointer; font-size: 15px !important;"
                               (click)="downloadAttachment(media.content,media.contentType,media.fileName)">{{media.fileName}}</a>
                        </div>

                    </div>
                    <div *ngIf="!showCommentsOnly && postItem.postReplies.length > 0" class="row col-md-12 like-content" style=" margin-top: 10px;margin-bottom: 10px">
                        <span class="pull-right comment-number" style=" padding-left: 22px;">
                            <span>
                                {{postItem.postReplies.length}}
                            </span><span><i class="fa fa-comments-o"></i></span>
                        </span>
                    </div>

                    <div class="social-chat" style="margin-top:0px !important">
                        <div *ngFor="let reply of postItem.postReplies | orderBy: 'createdDate'" class="your-msg" style="margin-bottom:0px">
                            <div class="media" style="padding: 15px;">
                                <img style="width: 35px !important; height: 35px;" class="img-50 img-fluid m-r-20 rounded-circle" alt=""
                                     [src]="reply.user.contactLogo">
                                <div class="media-body" style="padding: 0px; border: 0px;">
                                    <span class="f-w-600">
                                        {{reply.user.firstName}} {{reply.user.lastName}}
                                        <span>
                                            {{reply.createdDate | timeAgo}}
                                        </span>
                                        <span *ngIf="reply.isEdited" class="feed-time-date"> | Edited</span>
                                    </span>
                                    <div *ngIf="!reply.showEditPanel" class="row user-comment" style=" background-color: whitesmoke; border-radius: 10px; margin: 0px; margin-bottom: 0px; margin-top: 10px;">
                                        <pre style="white-space: pre-wrap;background-color: transparent; font-size: 14px !important; color: #252525; padding: 10px; margin: 0;">{{reply.body}}</pre>
                                    </div>
                                    <div *ngIf="reply.showEditPanel" class="row user-comment" style=" padding: 10px;">
                                        <textarea [(ngModel)]="reply.body" (keyup)=onCommentKeyUp($event,postItem) [rows]="postItem.rows" class="form-control feed-comment-box" rows="1" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Write a comment...'" style="resize: none; overflow-y: scroll;"></textarea>
                                        <div class="col-xl-12 text-right">
                                            <a (click)="editReply(reply)" class="" style="cursor:pointer; margin-right:15px;margin-left:15px">Save</a>
                                            <a (click)="cancelEditReply(reply)" class="" style="cursor:pointer;margin-right:15px;margin-left:15px">Cancel</a>
                                        </div>
                                    </div>
                                    <div class="row feed-comment-action" *ngIf="userId == reply.user.id && isSinglePost">
                                        <p style="margin-top: 5px; margin-bottom: 0;">
                                            <a (click)="deleteReply(reply)" style="float: right; padding: 10px; cursor: pointer;" class="action-link">Delete Reply</a>
                                            <a (click)="showEditReply(reply)" style="float: right; padding: 10px; cursor: pointer;" class="action-link">Edit Reply</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="comments-box" style="margin-top:0px">
                        <div class="media">
                            <img style=" width: 30px !important; height: 30px; top: 10px; position: relative; left: 10px;" class="img-50 img-fluid m-r-20 rounded-circle" alt=""
                                 [src]="myContactLogo">
                            <div class="media-body">
                                <div class="input-group text-box">
                                    <textarea [(ngModel)]="postItem.reply" class="form-control feed-comment-box" (keyup)=onCommentKeyUp($event,postItem) [rows]="postItem.rows" placeholder="Write a comment..." onfocus="this.placeholder = ''" onblur="this.placeholder = 'Write a comment...'" style="resize: none; overflow-y: scroll;"></textarea>
                                    <div class="col-md-1" style="margin: auto; font-size: 20px;" *ngIf="!postItem.replyLoading" (click)="sendPostReply(postItem,i)">

                                        <i class="fa fa-paper-plane" style=" padding-left: 10px; color: #00A6B6; cursor: pointer;"></i>
                                    </div>
                                    <div style="margin: auto; font-size: 20px;" class="col-md-1" *ngIf="postItem.replyLoading">
                                        <i class="fa fa-spinner" style="color: #00A6B6;"></i>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <div *ngIf="showLoading && !isSinglePost" class="col-xs-12 no-padding">
        <div class="row" style="margin-top: 15px;">
            <div class="text-center">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!isSinglePost" class="col-xs-12 no-padding">
        <div class="row" style="margin-top: 15px;">
            <div class="text-center">
                <a (click)="loadPosts()" style="font-size: 17px; cursor: pointer; color: #06acb7; " class="m-0 avenir-medium blue-green">Load more ...</a>
            </div>
        </div>
    </div>
    

</div>